// =============================================================================
// datosOts.js
// Listado OT - public.ot
// =============================================================================

import {
    mostrarToast,
    formatearFecha,
    obtenerUrlBackend
} from './utilerias.js';

const URL_BASE_API = obtenerUrlBackend('8083');
const URL_API = `${URL_BASE_API}/api/datosOts`;

let filtrosExpandidosOts = false;
let timerFiltroOts = null;
let preferenciaOts = null;
let timerGuardarPreferenciaOts = null;

const columnasFiltroOts = [
    'ot_num',
    'ot_prefijo',
    'ot_st',
    'ot_so',
    'ot_part',
    'ot_color_desc',
    'ot_cust',
    'ot_cust_name',
    'ot_ord_date',
    'ot_due_date'
];

// =============================================================================
// PREFERENCIA DE CONSULTA
// =============================================================================
async function cargarPreferenciaOts() {

    try {

        const respuesta =
            await fetch(
                `${URL_BASE_API}/api/preferencias/ots/ultima_consulta`,
                {
                    method: 'GET',

                    headers: {
                        'Authorization':
                            sessionStorage.getItem(
                                'token_teresita'
                            ),

                        'Content-Type':
                            'application/json'
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        if (
            resultado.success &&
            resultado.existe &&
            resultado.valor
        ) {

            preferenciaOts =
                resultado.valor;

        } else {

            preferenciaOts = null;

        }


    } catch (error) {

        console.error(
            'Error al recuperar última consulta OT:',
            error
        );

        preferenciaOts = null;

    }

}

// =============================================================================
// VISTA
// =============================================================================

export function paginadatosOts() {

    filtrosExpandidosOts = false;

    const html = `
        <div class="container-fluid ots-container">

            <div
                id="estado-contenedor"
                class="alert alert-info"
                role="alert"
                style="display:none;">
                <p id="mensaje-estado" class="mb-0">
                    Cargando datos del servidor...
                </p>
            </div>

            <div class="table-responsive ots-tabla-wrapper">

                <table
                    id="tabla-filtros"
                    class="table table-striped table-hover w-100 ots-tabla">

                    <thead class="table-light">

                        <tr>
                            <th>OT</th>
                            <th>Prefijo</th>
                            <th>ST</th>
                            <th>SO</th>
                            <th>Producto</th>
                            <th>Color</th>
                            <th>Cliente</th>
                            <th>Nombre cliente</th>
                            <th>Fecha orden</th>
                            <th class="ots-header-fecha-entrega">Fecha entrega</th>
                        </tr>

                        <tr
                            id="filaFiltrosOts"
                            class="ots-filtros"
                            style="display:none;">

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="0"
                                    data-campo="ot_num"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="1"
                                    data-campo="ot_prefijo"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="2"
                                    data-campo="ot_st"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="3"
                                    data-campo="ot_so"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="4"
                                    data-campo="ot_part"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="5"
                                    data-campo="ot_color_desc"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="6"
                                    data-campo="ot_cust"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="7"
                                    data-campo="ot_cust_name"
                                    autocomplete="off">
                            </th>

                            <th>
                                <input
                                    type="text"
                                    class="ots-filtro-columna form-control form-control-sm"
                                    data-columna="8"
                                    data-campo="ot_ord_date"
                                    placeholder="AAAA-MM-DD"
                                    autocomplete="off">
                            </th>

                            <th class="ots-filtro-ultima-columna">
                                <div class="ots-filtro-fecha-entrega-wrap">
                                    <input
                                        type="text"
                                        class="ots-filtro-columna form-control form-control-sm"
                                        data-columna="9"
                                        data-campo="ot_due_date"
                                        placeholder="AAAA-MM-DD"
                                        autocomplete="off">

                                    <button
                                        type="button"
                                        id="btnLimpiarFiltrosOts"
                                        class="ots-btn-limpiar-filtros"
                                        title="Limpiar filtros"
                                        aria-label="Limpiar filtros">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </th>

                        </tr>

                    </thead>

                    <tbody></tbody>

                </table>

            </div>

        </div>
    `;

    setTimeout(() => {
        inicializarDataTable();
    }, 100);

    return html;
}

// =============================================================================
// DATATABLE
// =============================================================================

async function inicializarDataTable() {
    await cargarPreferenciaOts();

    if (!window.$ || !$.fn.DataTable) {
        console.error('DataTables no está disponible.');
        mostrarToast('No fue posible inicializar la tabla OT', 'danger');
        return;
    }

    if ($.fn.DataTable.isDataTable('#tabla-filtros')) {
        $('#tabla-filtros').DataTable().destroy();
    }

    const columnasDef = [
        {
            data: 'ot_num',
            name: 'ot_num',
            title: 'OT',
            searchable: true,
            width: '130px',
            defaultContent: ''
        },
        {
            data: 'ot_prefijo',
            name: 'ot_prefijo',
            title: 'Prefijo',
            searchable: true,
            width: '70px',
            defaultContent: ''
        },
        {
            data: 'ot_st',
            name: 'ot_st',
            title: 'ST',
            searchable: true,
            width: '70px',
            defaultContent: ''
        },
        {
            data: 'ot_so',
            name: 'ot_so',
            title: 'SO',
            searchable: true,
            width: '110px',
            defaultContent: ''
        },
        {
            data: 'ot_part',
            name: 'ot_part',
            title: 'Producto',
            searchable: true,
            width: '160px',
            defaultContent: '',
            render: function(data, type) {

                if (type !== 'display') {
                    return data || '';
                }

                if (!data) {
                    return '';
                }

                return `
                    <button
                        type="button"
                        class="ots-articulo-link"
                        title="Ver detalle del artículo">
                        ${escapeHtml(data)}
                    </button>
                `;
            }
        },
        {
            data: 'ot_color_desc',
            name: 'ot_color_desc',
            title: 'Color',
            searchable: true,
            width: '140px',
            defaultContent: ''
        },
        {
            data: 'ot_cust',
            name: 'ot_cust',
            title: 'Cliente',
            searchable: true,
            width: '100px',
            defaultContent: ''
        },
        {
            data: 'ot_cust_name',
            name: 'ot_cust_name',
            title: 'Nombre cliente',
            searchable: true,
            width: '190px',
            defaultContent: ''
        },
        {
            data: 'ot_ord_date',
            name: 'ot_ord_date',
            title: 'Fecha orden',
            searchable: true,
            width: '110px',
            defaultContent: '',
            render: function(data, type) {
                if (!data) return '';
                if (type === 'display') return formatearFecha(data);
                return data;
            }
        },
        {
            data: 'ot_due_date',
            name: 'ot_due_date',
            title: 'Fecha entrega',
            searchable: true,
            width: '145px',
            defaultContent: '',
            render: function(data, type) {
                if (!data) return '';
                if (type === 'display') return formatearFecha(data);
                return data;
            }
        }
    ];

    const filtrosGuardados =
    preferenciaOts?.filtros || {};
    const searchCols =
    columnasFiltroOts.map(
        campo => ({
            search:
                filtrosGuardados[campo] || ''
            })
        );

    const table = $('#tabla-filtros').DataTable({

        serverSide: true,
        processing: true,
        searchCols: searchCols,

        ajax: {
            url: URL_API,
            type: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token_teresita'),
                'Content-Type': 'application/json'
            },
            error: function(xhr) {
                console.error('Fallo de red en DataTable OT:', xhr);
                mostrarToast('Error al obtener registros OT', 'danger');
            }
        },

        columns: columnasDef,
        deferRender: true,
        autoWidth: false,
        retrieve: true,

        stateSave: false,

        language: {
            url: 'https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json'
        },

        paging: true,
        pageLength: preferenciaOts?.registrosPorPagina || 25,
        lengthChange: true,
        lengthMenu: [
            [10, 25, 50, 100],
            [10, 25, 50, 100]
        ],

        order: [[preferenciaOts?.orden?.columna ?? 0, preferenciaOts?.orden?.direccion ?? 'asc']],
        scrollX: false,

        // Solo la primera fila del thead debe ordenar.
        orderCellsTop: true,

        dom:
            '<"row mb-3 align-items-center"' +
                '<"col-sm-6"B>' +
                '<"col-sm-6 text-end"l>' +
            '>rt' +
            '<"row"' +
                '<"col-sm-6"i>' +
                '<"col-sm-6"p>' +
            '>',

        buttons: [
            {
                extend: 'collection',
                text: '<i class="fas fa-download"></i> Exportar',
                className: 'btn btn-sm',
                buttons: [
                    {
                        extend: 'copy',
                        text: '<i class="fas fa-copy"></i> Copiar',
                        exportOptions: { columns: ':visible' }
                    },
                    {
                        extend: 'excel',
                        text: '<i class="fas fa-file-excel"></i> Excel',
                        exportOptions: { columns: ':visible' }
                    },
                    {
                        extend: 'pdf',
                        text: '<i class="fas fa-file-pdf"></i> PDF',
                        orientation: 'landscape',
                        exportOptions: { columns: ':visible' }
                    },
                    {
                        extend: 'print',
                        text: '<i class="fas fa-print"></i> Imprimir',
                        exportOptions: { columns: ':visible' }
                    }
                ]
            }
        ],

        initComplete: function() {

            const api = this.api();

            // DataTables ya terminó de construir el encabezado.
            // Ahora insertamos el control dentro de la columna 10 real.
            crearBotonToggleFiltrosOts(api);

            configurarFiltrosOts(api);
            restaurarValoresFiltrosOts(api);
            configurarBotonesFiltrosOts(api);

            const paginaGuardada = Number(preferenciaOts?.pagina || 0);
                if (paginaGuardada > 0) {api.page(paginaGuardada).draw('page');
                }
        }
    });

    configurarClickArticuloOts(table);

    table.on('page.dt length.dt order.dt', () => {programarGuardarPreferenciaOts(table);});
}

// =============================================================================
// BOTÓN EXPANDIR / CONTRAER
// =============================================================================

function crearBotonToggleFiltrosOts(api) {

    const headerFechaEntrega = api.column(9).header();

    if (!headerFechaEntrega) return;

    // Evitar duplicarlo si DataTables restaura/redibuja estado.
    if (headerFechaEntrega.querySelector('#btnToggleFiltrosOts')) {
        return;
    }

    headerFechaEntrega.classList.add('ots-header-con-toggle');

    const boton = document.createElement('button');

    boton.type = 'button';
    boton.id = 'btnToggleFiltrosOts';
    boton.className = 'ots-btn-toggle-filtros';
    boton.title = 'Mostrar filtros';
    boton.setAttribute('aria-label', 'Mostrar filtros');

    boton.innerHTML = `
        <i
            id="iconToggleFiltrosOts"
            class="fas fa-chevron-down">
        </i>
    `;

    // El botón no debe activar el ordenamiento de DataTables.
    ['click', 'mousedown', 'mouseup'].forEach(nombreEvento => {
        boton.addEventListener(nombreEvento, event => {
            event.preventDefault();
            event.stopPropagation();
        });
    });

    headerFechaEntrega.appendChild(boton);
}

// =============================================================================
// FILTROS
// =============================================================================

function configurarFiltrosOts(api) {

    const inputs = document.querySelectorAll('.ots-filtro-columna');

    inputs.forEach(input => {

        ['click', 'mousedown', 'mouseup'].forEach(nombreEvento => {
            input.addEventListener(nombreEvento, event => {
                event.stopPropagation();
            });
        });

        input.addEventListener('input', function() {

            const indice = Number(this.dataset.columna);
            const valor = this.value;

            if (!Number.isInteger(indice)) return;

            clearTimeout(timerFiltroOts);

            timerFiltroOts = setTimeout(() => {

                const columna = api.column(indice);

                if (columna.search() !== valor) {
                    columna.search(valor).draw();
                    programarGuardarPreferenciaOts(api);
                }

            }, 400);
        });
    });
}

function restaurarValoresFiltrosOts(api) {

    document
        .querySelectorAll('.ots-filtro-columna')
        .forEach(input => {

            const indice = Number(input.dataset.columna);

            if (!Number.isInteger(indice)) return;

            input.value = api.column(indice).search() || '';
        });
}

function configurarBotonesFiltrosOts(api) {

    const btnToggle = document.getElementById('btnToggleFiltrosOts');
    const btnLimpiar = document.getElementById('btnLimpiarFiltrosOts');

    btnToggle?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        alternarFiltrosOts();
    });

    btnLimpiar?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        limpiarFiltrosOts(api);
    });
}

function alternarFiltrosOts() {

    filtrosExpandidosOts = !filtrosExpandidosOts;

    const fila = document.getElementById('filaFiltrosOts');
    const icono = document.getElementById('iconToggleFiltrosOts');
    const boton = document.getElementById('btnToggleFiltrosOts');

    if (!fila || !icono) return;

    if (filtrosExpandidosOts) {

        fila.style.display = 'table-row';

        icono.classList.remove('fa-chevron-down');
        icono.classList.add('fa-chevron-up');

        if (boton) {
            boton.title = 'Ocultar filtros';
            boton.setAttribute('aria-label', 'Ocultar filtros');
        }

    } else {

        fila.style.display = 'none';

        icono.classList.remove('fa-chevron-up');
        icono.classList.add('fa-chevron-down');

        if (boton) {
            boton.title = 'Mostrar filtros';
            boton.setAttribute('aria-label', 'Mostrar filtros');
        }
    }
}

async function limpiarFiltrosOts(api) {

    clearTimeout(timerFiltroOts);

    document
        .querySelectorAll('.ots-filtro-columna')
        .forEach(input => {
            input.value = '';
        });

    columnasFiltroOts.forEach((campo, indice) => {
        api.column(indice).search('');
    });

    api.search('');
    //api.state.save();
    api.draw();    
    await guardarPreferenciaOts(api);
}

// =============================================================================
// CLICK EN PRODUCTO / ARTÍCULO
// =============================================================================

function configurarClickArticuloOts(table) {

    $('#tabla-filtros tbody')
        .off('click', '.ots-articulo-link')
        .on('click', '.ots-articulo-link', function(event) {

            event.preventDefault();
            event.stopPropagation();

            const fila = $(this).closest('tr');
            const data = table.row(fila).data();

            if (!data) return;

            abrirDetalleOts(data);
        });
}

function abrirDetalleOts(data) {

    sessionStorage.setItem(
        'filtroOtsSeleccionado',
        JSON.stringify({
            ot_num: data.ot_num || '',
            ot_prefijo: data.ot_prefijo || '',
            ot_st: data.ot_st || '',
            ot_so: data.ot_so || '',
            ot_part: data.ot_part || '',
            ot_color_desc: data.ot_color_desc || '',
            ot_cust: data.ot_cust || '',
            ot_cust_name: data.ot_cust_name || '',
            ot_ord_date: data.ot_ord_date || '',
            ot_due_date: data.ot_due_date || ''
        })
    );

    const listado = document.querySelector('.ots-container');

    if (listado) {
        listado.style.display = 'none';
    }

    const areaContenido =
        document.querySelector('.content') ||
        document.getElementById('app') ||
        document.body;

    let contenedorDetalle =
        document.getElementById('contenedor-detalle-ots');

    if (!contenedorDetalle) {
        contenedorDetalle = document.createElement('div');
        contenedorDetalle.id = 'contenedor-detalle-ots';
        areaContenido.appendChild(contenedorDetalle);
    }

    contenedorDetalle.innerHTML = '';
    contenedorDetalle.style.display = 'block';

    import('./informeDetOts.js')
        .then(module => {
            module.mostrarDetalleOts(
                data,
                contenedorDetalle
            );
        })
        .catch(error => {

            console.error(
                'Error al cargar detalle OT:',
                error
            );

            mostrarToast(
                'Error al cargar vista de detalle',
                'danger'
            );

            if (listado) {
                listado.style.display = 'block';
            }

            contenedorDetalle.style.display = 'none';
        });
}

// =============================================================================
// UTILIDAD
// =============================================================================

function escapeHtml(valor) {

    return String(valor ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
}


// =============================================================================
// GUARDAR PREFERENCIA DE CONSULTA
// =============================================================================
async function guardarPreferenciaOts(
    api
) {

    try {

        const filtros = {};


        columnasFiltroOts.forEach(
            (campo, indice) => {

                filtros[campo] =
                    api
                        .column(indice)
                        .search() || '';

            }
        );


        const ordenActual =
            api.order();


        const valor = {

            filtros,

            pagina:
                api.page(),

            registrosPorPagina:
                api.page.len(),

            orden: {

                columna:
                    ordenActual?.[0]?.[0] ?? 0,

                direccion:
                    ordenActual?.[0]?.[1] ?? 'asc'

            }

        };


        const respuesta =
            await fetch(
                `${URL_BASE_API}/api/preferencias/ots/ultima_consulta`,
                {

                    method: 'PUT',

                    headers: {

                        'Authorization':
                            sessionStorage.getItem(
                                'token_teresita'
                            ),

                        'Content-Type':
                            'application/json'

                    },

                    body:
                        JSON.stringify({
                            valor
                        })

                }
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error ${respuesta.status}`
            );

        }


    } catch (error) {

        console.error(
            'Error al guardar última consulta OT:',
            error
        );

    }

}

// =============================================================================
// PROGRAMAR GUARDADO DE PREFERENCIA DE CONSULTA
// =============================================================================
function programarGuardarPreferenciaOts(
    api
) {

    clearTimeout(
        timerGuardarPreferenciaOts
    );


    timerGuardarPreferenciaOts =
        setTimeout(
            () => {

                guardarPreferenciaOts(
                    api
                );

            },
            500
        );

}
